// ────────────────────────────
// src/components/MobileAppSection.jsx
// ────────────────────────────
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import {
  RiRocket2Line,
  RiFingerprintLine,
  RiDownloadCloud2Line,
} from "react-icons/ri";

import CONFIG from "../config/config";

import "swiper/css";
import "swiper/css/pagination";
import "animate.css";
import "./MobileAppSection.css";

import iphoneMockup1 from "../assets/images/mobile-screenshots/mobile-home-dark.png";
import iphoneMockup2 from "../assets/images/mobile-screenshots/mobile-routine-dark.png";
import iphoneMockup3 from "../assets/images/mobile-screenshots/mobile-routine-details-dark.png";
import iphoneMockup4 from "../assets/images/mobile-screenshots/mobile-routine-video-dark.png";
import iphoneMockup5 from "../assets/images/mobile-screenshots/mobile-routine-comment-dark.png";
// import iphoneMockup6 from "../assets/images/mobile-screenshots/mobile-routine-information-dark.png";
import iphoneMockup7 from "../assets/images/mobile-screenshots/mobile-diet-dark.png";
import iphoneMockup8 from "../assets/images/mobile-screenshots/mobile-progress-dark.png";
// import iphoneMockup9 from "../assets/images/mobile-screenshots/mobile-profile-dark.png";
// import iphoneMockup10 from "../assets/images/mobile-screenshots/mobile-home-dark.png";
// import iphoneMockup11 from "../assets/images/mobile-screenshots/mobile-routine-dark.png";
// import iphoneMockup12 from "../assets/images/mobile-screenshots/mobile-diet-dark.png";
// import iphoneMockup13 from "../assets/images/mobile-screenshots/mobile-progress-dark.png";
// import iphoneMockup14 from "../assets/images/mobile-screenshots/mobile-home-dark.png";
// import iphoneMockup15 from "../assets/images/mobile-screenshots/mobile-routine-dark.png";
// import iphoneMockup16 from "../assets/images/mobile-screenshots/mobile-diet-dark.png";
// import iphoneMockup17 from "../assets/images/mobile-screenshots/mobile-progress-dark.png";

// import mobileHome from "../assets/images/mobile-screenshots/mobile-home-dark.png";
// const slides = Array(12).fill(mobileHome);


const MOBILE_SHOTS = [
  iphoneMockup1, 
  iphoneMockup2, 
  iphoneMockup3, 
  iphoneMockup4,
  iphoneMockup5,
  // iphoneMockup6,
  iphoneMockup7,
  iphoneMockup8,
  // iphoneMockup9,
  // iphoneMockup10,
  // iphoneMockup11,
  // iphoneMockup12,
  // iphoneMockup13,
  // iphoneMockup14,
  // iphoneMockup15,
  // iphoneMockup16
];

/* ——— alts para los mock-ups móviles ——— */
const MOBILE_ALTS = [
  /* 0 */ "Pantalla de inicio de la aplicación de entrenamiento personal Zasfit en móvil",
  /* 1 */ "Vista de rutina diaria en la app para entrenadores personales Zasfit",
  /* 2 */ "Detalle de ejercicio de rutina en la aplicación Zasfit",
  /* 3 */ "Reproducción de vídeo de ejercicio en la app de entrenamiento personal Zasfit",
  /* 4 */ "Comentarios del cliente sobre la rutina en la aplicación para entrenadores Zasfit",
  /* 5 */ "Plan de dieta semanal en la aplicación de nutrición Zasfit",
  /* 6 */ "Gráfico de progreso del cliente en la app de entrenamiento personal Zasfit"
];

/* ——— alts para mock-ups NO usados (manténlos comentados) ——— */
// const ALT_MOCKUP6  = "Información del ejercicio en la app para entrenadores Zasfit";
// const ALT_MOCKUP9  = "Perfil del cliente en la app para entrenadores personales Zasfit";
// const ALT_MOCKUP10 = "Pantalla de inicio alternativa – aplicación Zasfit";
// const ALT_MOCKUP11 = "Vista alternativa de rutina – app de entrenamiento Zasfit";
// const ALT_MOCKUP12 = "Plan de dieta alternativo – aplicación de nutrición Zasfit";
// const ALT_MOCKUP13 = "Gráfico de progreso alternativo – app de entrenamiento Zasfit";
// const ALT_MOCKUP14 = "Pantalla de inicio (modo claro) – aplicación Zasfit";
// const ALT_MOCKUP15 = "Rutina (modo claro) – app para entrenadores Zasfit";
// const ALT_MOCKUP16 = "Dieta (modo claro) – aplicación Zasfit";
// const ALT_MOCKUP17 = "Progreso (modo claro) – app de entrenamiento Zasfit";

const { APP_STORE_ID, ANDROID_APP_IDENTIFIER } = CONFIG;

const CAMPAIGN = "landing_mobile";

const buildAppStoreUrl = (lang = "es") =>
  `https://apps.apple.com/${lang}/app/id${APP_STORE_ID}?itscg=30200&itsct=${CAMPAIGN}&platform=iphone`;

const buildPlayUrl = (lang = "es") => {
  const ref = encodeURIComponent(`utm_source=landing&utm_campaign=${CAMPAIGN}`);
  return `https://play.google.com/store/apps/details?id=${ANDROID_APP_IDENTIFIER}&hl=${lang}&referrer=${ref}`;
};

const STATIC_BASE = `https://zasfit.io`;
const iosBadge  = `${STATIC_BASE}/static/media/app-store-badge.png`;
const playBadge = `${STATIC_BASE}/static/media/google-play-badge.png`;

export default function MobileAppSection() {
  const isMobile = window.matchMedia('(max-width: 991.98px)').matches;

  const swiperProps = isMobile
  ? {
      // allowTouchMove: false,
      // touchStartPreventDefault: false,
      grabCursor: false,        // manita desactivada
    }
  : {
      // allowTouchMove: true,
      grabCursor: true,         // manita visible
    };

  return (
    <section id="mobileapp" className="mobile-app-section bg-color pt-50 pb-75">
      {/* decoraciones */}
      <span
        className="mob-ellipse mob-ellipse--left  mob-ellipse--big"
        aria-hidden="true"
      />
      <span
        className="mob-ellipse mob-ellipse--right mob-ellipse--small"
        aria-hidden="true"
      />
      <div className="hero-bg" />

      {/* ───── TÍTULO ───── */}
      <div
        className="
          mobile-title text-center pb-0
          wow animate__animated animate__fadeInUpShort
        "
        data-wow-duration="1.2s"
      >
        <h2
          className="mobile-eyebrow eyebrow-label wow animate__animated animate__fadeInUp"
          data-wow-delay="0.1s"
          data-wow-duration="1s"
        >
          App para Clientes
        </h2>

        <h3
          className="section-hook wow animate__animated animate__fadeInUp"
          data-wow-delay="0.18s"
          data-wow-duration="1s"
        >
          La Aplicación Móvil<br/> más<span className="gradient-text"> TOP del mercado</span>
        </h3>

        <p
          className="desc wow animate__animated animate__fadeInUp"
          data-wow-delay="0.25s"
          data-wow-duration="1s"
        >
          Consigue más renovaciones con una app increíble que te ayuda a afianzar a tus clientes.
        </p>
      </div>

      {/* ───── FEATURES ───── */}
      <ul className="features-row">
        {[
          { cls: "free", Icon: RiDownloadCloud2Line, txt: "Gratuita", d: 0.3 },
          { cls: "secure", Icon: RiFingerprintLine, txt: "Segura", d: 0.45 },
          { cls: "fast", Icon: RiRocket2Line, txt: "Rápida", d: 0.55 },
        ].map(({ cls, Icon, txt, d }) => (
          <li
            key={txt}
            className="
              feature-box
              wow animate__animated animate__fadeInUpShort
            "
            data-wow-delay={`${d}s`}
            data-wow-duration="1s"
          >
            <span className={`icon ${cls}`}>
              <Icon />
            </span>
            <h3 className="feature-title">{txt}</h3>
          </li>
        ))}
      </ul>

      {/* ───── SWIPER ───── */}
      <div
        className="
          screenshots-wrapper
          wow animate__animated animate__fadeIn
        "
        data-wow-delay="0.25s"
        data-wow-duration="0.8s"
      >
        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={5}
          loop
          autoplay={{
            delay: 2200,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            stopOnLastSlide: false,
            waitForTransition: true,
          }}
          breakpoints={{
            0:   { slidesPerView: 3, spaceBetween: 18 },  // 0 – 600 px
            601: { slidesPerView: 5, spaceBetween: 25 }   // ≥ 601 px
          }}
          speed={800}
          spaceBetween={25}
          {...swiperProps}
          className="screenshots-swiper swiper--noTouch"
        >
          {MOBILE_SHOTS.map((src, i) => (
            <SwiperSlide key={i}>
              <img src={src} alt={MOBILE_ALTS[i]} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* ───── STORE NOTE ───── */}
      {/* <p
        className="
          store-note text-center
          wow animate__animated animate__fadeIn
        "
        data-wow-delay="0.15s"
        data-wow-duration="1s"
      >
        Disponible en&nbsp;<strong>iOS</strong>&nbsp;y&nbsp;<strong>Android</strong>
      </p> */}

      {/* ───── BADGES ───── */}
      <div className="app-btn-box mt-50">
        {/* iOS */}
        <a href={buildAppStoreUrl()} target="_blank" rel="noopener noreferrer">
          <img
            src={iosBadge}
            alt="Descargar Zasfit en App Store"
            className="
              store-badge
              wow animate__animated animate__fadeInLeftShort
            "
            data-wow-delay="0.15s"
            data-wow-duration="1s"
          />
        </a>

        {/* Android */}
        <a href={buildPlayUrl()} target="_blank" rel="noopener noreferrer">
          <img
            src={playBadge}
            alt="Descargar Zasfit en Google Play"
            className="
              store-badge
              wow animate__animated animate__fadeInRightShort
            "
            data-wow-delay="0.15s"
            data-wow-duration="0.8s"
          />
        </a>
      </div>
    </section>
  );
}
